module.exports = __webpack_public_path__ + "img/zs12.398ea82f.jpg";